var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "92px",
    height: "92px",
    viewBox: "0 0 92 92",
    enableBackground: "new 0 0 92 92",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_132_",
    d: "M46,47.5c-2.2,0-4-1.8-4-4V9c0-2.2,1.8-4,4-4s4,1.8,4,4v34.5C50,45.7,48.3,47.5,46,47.5z M84,48.8 c0-14.6-8.1-27.7-21.1-34.2c-2-1-4.4-0.2-5.4,1.8c-1,2-0.2,4.4,1.8,5.4C69.6,26.9,76,37.3,76,48.8C76,65.5,62.5,79,46,79 c-16.5,0-30-13.5-30-30.2c0-11.6,6.4-21.9,16.7-27.1c2-1,2.8-3.4,1.8-5.4c-1-2-3.4-2.8-5.4-1.8C16.1,21.1,8,34.2,8,48.8 C8,69.9,25,87,46,87C67,87,84,69.9,84,48.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.195fb0cab9e53c897d194722f4104dbd.svg";
export { ForwardRef as ReactComponent };